import { gql } from '../../../../types/__codegen__/sanity';

export const GET_ALL_OFFERS = gql(`
  query AllOffer {
    allOffer {
      _id
      _type
      id: _id
      _createdAt
      release {
        ...ReleaseFields
      }
      canBeRedeemedWithPromoCode {
        code {
          current
        }
        codeType
        description: descriptionRaw
      }
      minimumGapInCoverDays
      detailsTeaser
      targetsSegments {
        identifier {
          current
        }
      }
      identifier {
        current
      }
      offerTypes {
        _id
        name
        identifier {
          current
        }
        slogan: sloganRaw
        description: descriptionRaw
        givesAccessToOneOfRewards {
          identifier {
            current
          }
          name
        }
        fulfilledAfterDays
        ...OfferTypeConditionsFields
        imageObject {
          ...ImageObjectFields
        }
        summary
      }
    }
  }
`);

export const GET_OFFER_BY_IDENTIFIER = gql(`
  query OfferByIdentifier($identifier: String) {
    allOffer(where: { identifier: { current: { eq: $identifier } } }) {
      _id
      _type
      id: _id
      _createdAt
      release {
        ...ReleaseFields
      }
      canBeRedeemedWithPromoCode {
        code {
          current
        }
        codeType
        description: descriptionRaw
      }
      minimumGapInCoverDays
      detailsTeaser
      targetsSegments {
        identifier {
          current
        }
      }
      identifier {
        current
      }
      howTo {
        ...HowToFields
      }
      offerTypes {
        _id
        name
        identifier {
          current
        }
        slogan: sloganRaw
        description: descriptionRaw
        givesAccessToOneOfRewards {
          identifier {
            current
          }
          name
        }
        fulfilledAfterDays
        ...OfferTypeConditionsFields
        imageObject {
          ...ImageObjectFields
        }
        summary
      }
    }
  }
`);

export const GET_OFFER_BY_IDENTIFIER_WITH_ORGANISATION = gql(`
  query OfferByIdentifierWithOrganisation($identifier: String) {
    allOffer(where: { identifier: { current: { eq: $identifier } } }) {
      _id
      _type
      id: _id
      _createdAt
      release {
        ...ReleaseFields
      }
      canBeRedeemedWithPromoCode {
        code {
          current
        }
        codeType
        description: descriptionRaw
      }
      minimumGapInCoverDays
      detailsTeaser
      targetsSegments {
        identifier {
          current
        }
      }
      identifier {
        current
      }
      howTo {
        ...HowToFields
      }
      offerTypes {
        _id
        name
        identifier {
          current
        }
        slogan: sloganRaw
        description: descriptionRaw
        givesAccessToOneOfRewards {
          identifier {
            current
          }
          name
        }
        fulfilledAfterDays
        ...OfferTypeConditionsFields
        offeredByOrganization {
          name
          identifier {
            current
          }
          logo {
            ...ImageFields
          }
          termsAndConditions: termsAndConditionsRaw
          isFulfilledUsingSourceCodes {
            appliesToServiceChannel {
              name
            }
            code {
              current
            }
          }
        }
        imageObject {
          ...ImageObjectFields
        }
        summary
      }
    }
  }
`);
